<h2 mat-dialog-title>Create a new College</h2>

<mat-progress-bar
  mode="indeterminate"
  color="accent"
  *ngIf="loading"
></mat-progress-bar>
<mat-dialog-content>
  <p>Enter the college name and email domain to create a new college.</p>

  <form [formGroup]="newCollegeForm" class="flex flex-col">
    <mat-form-field>
      <mat-label> Name</mat-label>
      <input
        matInput
        type="text"
        formControlName="name"
        placeholder="Ex. Pennsylvania State University"
        maxlength=""
      />
      <mat-error *ngIf="this.newCollegeForm.controls.name.invalid">
        College name is required.
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Email Domain </mat-label>
      <input
        matInput
        type="text"
        formControlName="emailDomain"
        placeholder="Ex. psu.edu"
        maxlength=""
      />
      <mat-error *ngIf="this.newCollegeForm.controls.emailDomain.invalid">
        Email domain is required.
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button
    mat-raised-button
    (click)="onSubmit()"
    [disabled]="newCollegeForm.invalid"
    color="accent"
  >
    Submit
  </button>
</mat-dialog-actions>
